import React from 'react';

import '../Passport.css';
import './AuthWindow.css';

type AuthWindowProps = {
    children: JSX.Element,
    image: string,
    source_url: string,
    author: string,
    author_url: string
}

const AuthWindow = (({ image, author_url, author, source_url, children }: AuthWindowProps) => {
    return (<div className="Passport container-fluid">
    <div className="row">
      <div className="fixed-100 back hidden-xs">
        <img src={image} className="img-fluid" />
        <div className="fixed-image-caption">Photo by&nbsp;
            <a className="underlined" target="_blank" href={author_url}>
                {author}
            </a>&nbsp;
            from <a className="underlined" target="_blank" href={source_url}>Pexels</a>
        </div>
      </div>
      <div className="fixed-100 fore">
        {children}
    </div>
  </div>
</div>
);
})

export default AuthWindow
